(function () {
  'use strict';

  var overlay = document.getElementById('t360-overlay');
  var backdrop = document.getElementById('t360-backdrop');
  var closeBtn = document.getElementById('t360-close');
  var resetBtn = document.getElementById('t360-reset');
  var titleEl = document.getElementById('t360-title');
  var hintEl = document.getElementById('t360-hint');
  var stage = document.getElementById('t360-stage');
  var imageEl = document.getElementById('t360-image');
  var loadingEl = document.getElementById('t360-loading');
  var modelWrap = document.getElementById('t360-model-wrap');
  var modelEl = document.getElementById('t360-model');

  if (!overlay || !stage || !imageEl) return;

  var IMAGE_HINT = 'Drag left/right to rotate. Drag up/down to change view angle. Scroll or pinch to zoom.';
  var MODEL_HINT = 'Drag in any direction to rotate. Scroll or pinch to zoom.';

  var grid = [];
  var rowCount = 1;
  var rowIndex = 0;
  var colIndex = 0;
  var isOpen = false;
  var isDragging = false;
  var startX = 0;
  var startY = 0;
  var lastX = 0;
  var lastY = 0;
  var gestureAxis = null;
  var zoom = 1;
  var offsetX = 0;
  var offsetY = 0;
  var lastTouchDistance = 0;
  var dragThresholdX = 12;
  var dragThresholdY = 72;
  var axisLockThreshold = 10;
  var axisLockRatio = 1.35;
  var activeMode = 'image';
  var modelDefaultOrbit = null;
  var modelDefaultFov = null;

  function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
  }

  function hasModelForProduct(productId) {
    return !!(modelWrap && modelEl && modelWrap.dataset.modelProductId === String(productId));
  }

  function getFrameName(src) {
    var clean = String(src || '').split('?')[0].split('#')[0];
    try { clean = decodeURIComponent(clean); } catch (err) {}
    return clean.split('/').pop() || clean;
  }

  function normalizeFrameSrc(src) {
    var value = String(src || '');
    if (value.indexOf('//') === 0) return 'https:' + value;
    if (value.indexOf('http://cdn.shopify.com/') === 0) return value.replace('http://', 'https://');
    if (value.indexOf('http://dmpcvt-aj.myshopify.com/cdn/') === 0) return value.replace('http://', 'https://');
    return value;
  }

  function padNumber(value, width) {
    var text = String(value);
    while (text.length < width) text = '0' + text;
    return text;
  }

  function parseFrameCoordinate(src, fallbackIndex) {
    var name = getFrameName(src);
    var match = name.match(/(?:^|[-_\s])r(\d{1,3})([-_\s])c(\d{1,4})(?=\D|$)/i);
    if (!match) return null;
    return {
      src: normalizeFrameSrc(src),
      row: parseInt(match[1], 10),
      col: parseInt(match[3], 10),
      rowWidth: match[1].length,
      colWidth: match[3].length,
      fallbackIndex: fallbackIndex
    };
  }

  function createCoordinateSrc(template, row, col) {
    return normalizeFrameSrc(template.src).replace(
      /r(\d{1,3})([-_\s])c(\d{1,4})(?=\D|$)/i,
      'r' + padNumber(row, template.rowWidth) + '$2c' + padNumber(col, template.colWidth)
    );
  }

  function naturalCompare(a, b) {
    return getFrameName(a).localeCompare(getFrameName(b), undefined, {
      numeric: true,
      sensitivity: 'base'
    });
  }

  function buildCoordinateGrid(frames, configuredRows) {
    var parsed = frames.map(parseFrameCoordinate).filter(Boolean);
    if (parsed.length !== frames.length) return null;

    var rows = [];
    var rowMap = {};
    var cols = [];
    var colMap = {};
    var templateByCol = {};
    parsed.forEach(function (item) {
      if (!rowMap[item.row]) {
        rowMap[item.row] = {};
        rows.push(item.row);
      }
      if (!colMap[item.col]) {
        colMap[item.col] = true;
        cols.push(item.col);
      }
      if (!templateByCol[item.col]) templateByCol[item.col] = item;
      rowMap[item.row][item.col] = item;
    });

    rows.sort(function (a, b) { return a - b; });
    cols.sort(function (a, b) { return a - b; });

    var configuredRowCount = parseInt(configuredRows, 10) || rows.length;
    var rowNumbers = rows.slice();
    if (configuredRowCount > rows.length && rows[0] === 1) {
      rowNumbers = [];
      for (var r = 1; r <= configuredRowCount; r++) rowNumbers.push(r);
    }

    var synthesizedCount = 0;
    var matrix = rowNumbers.map(function (row) {
      return cols.map(function (col) {
        var item = rowMap[row] && rowMap[row][col];
        if (item) return item.src;
        synthesizedCount += 1;
        return createCoordinateSrc(templateByCol[col] || parsed[0], row, col);
      });
    });

    if (synthesizedCount > 0) {
      console.warn('[360 View] Filled ' + synthesizedCount + ' missing frames from rXX-cXXX filename pattern. Check Shopify list.file_reference limits and uploaded filenames.');
    }
    return matrix;
  }

  function buildFallbackGrid(frames, configuredRows) {
    var sorted = frames.slice().sort(naturalCompare);
    var rows = Math.max(1, parseInt(configuredRows, 10) || 3);
    if (sorted.length % rows !== 0) rows = 1;
    var cols = Math.floor(sorted.length / rows) || sorted.length;
    var matrix = [];
    for (var r = 0; r < rows; r++) {
      matrix.push(sorted.slice(r * cols, (r + 1) * cols));
    }
    return matrix;
  }

  function buildGrid(frames, configuredRows) {
    var coordinateGrid = buildCoordinateGrid(frames, configuredRows);
    if (coordinateGrid) return coordinateGrid;

    console.warn('[360 View] Some frame names do not match r01-c001 naming. Falling back to natural filename order.');
    return buildFallbackGrid(frames, configuredRows);
  }

  function showModelStage(title) {
    activeMode = 'model';
    imageEl.hidden = true;
    if (loadingEl) loadingEl.style.display = 'none';
    modelWrap.hidden = false;
    if (hintEl) hintEl.textContent = MODEL_HINT;
    if (titleEl) titleEl.textContent = title || 'Product 3D View';
    modelDefaultOrbit = null;
    modelDefaultFov = null;
    modelEl.addEventListener('load', function onLoad() {
      modelEl.removeEventListener('load', onLoad);
      try {
        modelDefaultOrbit = modelEl.getCameraOrbit ? modelEl.getCameraOrbit() : null;
        modelDefaultFov = modelEl.getFieldOfView ? modelEl.getFieldOfView() : null;
      } catch (err) {
        modelDefaultOrbit = null;
        modelDefaultFov = null;
      }
    });
  }

  function showImageStage(data) {
    activeMode = 'image';
    if (modelWrap) modelWrap.hidden = true;
    imageEl.hidden = false;

    var flat = data.frames.filter(Boolean);
    grid = buildGrid(flat, data.rows);
    rowCount = grid.length || 1;

    var configuredRow = parseInt(data.defaultRow, 10);
    rowIndex = Number.isFinite(configuredRow) && configuredRow > 0
      ? clamp(configuredRow - 1, 0, rowCount - 1)
      : Math.floor((rowCount - 1) / 2);
    colIndex = 0;
    zoom = 1;
    offsetX = 0;
    offsetY = 0;
    lastTouchDistance = 0;
    gestureAxis = null;

    if (hintEl) hintEl.textContent = IMAGE_HINT;
    if (titleEl) titleEl.textContent = data.title || 'Product 360 View';
    if (loadingEl) loadingEl.style.display = 'flex';
    imageEl.classList.remove('is-ready');
    imageEl.alt = (data.title || 'Product') + ' 360 view';
    setFrame(rowIndex, 0);
    applyTransform();
    preloadFrames();
  }

  function openViewer(productId) {
    var dataEl = document.getElementById('product-360-' + productId);
    var data = null;
    if (dataEl) {
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (err) {
        console.warn('[360 View] Invalid product data', err);
      }
    }

    var useModel = hasModelForProduct(productId);
    var useImages = !!(data && data.frames && data.frames.filter(Boolean).length >= 2);

    if (!useModel && !useImages) return;

    if (useModel) {
      showModelStage(data && data.title);
    } else {
      showImageStage(data);
    }

    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    isOpen = true;
  }

  function closeViewer() {
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    stage.classList.remove('is-dragging');
    isOpen = false;
    isDragging = false;
    gestureAxis = null;
  }

  function markImageReady() {
    if (loadingEl) loadingEl.style.display = 'none';
    imageEl.classList.add('is-ready');
  }

  function setFrame(row, col) {
    if (!grid.length) return;
    rowIndex = clamp(row, 0, grid.length - 1);
    var cols = grid[rowIndex].length;
    if (!cols) return;
    colIndex = ((col % cols) + cols) % cols;
    imageEl.onload = markImageReady;
    imageEl.onerror = markImageReady;
    imageEl.src = grid[rowIndex][colIndex];
    if (imageEl.complete) markImageReady();
  }

  function preloadFrames() {
    grid.forEach(function (row) {
      row.forEach(function (src) {
        var img = new Image();
        img.src = src;
      });
    });
  }

  function lockGestureAxis(totalX, totalY) {
    if (gestureAxis) return gestureAxis;
    var absX = Math.abs(totalX);
    var absY = Math.abs(totalY);
    if (absX < axisLockThreshold && absY < axisLockThreshold) return null;

    if (absX >= absY * axisLockRatio) gestureAxis = 'x';
    else if (absY >= absX * axisLockRatio) gestureAxis = 'y';
    return gestureAxis;
  }

  function rotateColumns(deltaX) {
    if (!grid.length) return;
    var stepX = Math.trunc(deltaX / dragThresholdX);
    if (stepX === 0) return;
    setFrame(rowIndex, colIndex - stepX);
    lastX += stepX * dragThresholdX;
  }

  function rotateRows(deltaY) {
    if (!grid.length || grid.length < 2) return;
    var stepY = Math.trunc(deltaY / dragThresholdY);
    if (stepY === 0) return;
    setFrame(rowIndex - stepY, colIndex);
    lastY += stepY * dragThresholdY;
  }

  function applyTransform() {
    imageEl.style.transform = 'translate(' + offsetX + 'px, ' + offsetY + 'px) scale(' + zoom + ')';
  }

  function resetView() {
    if (activeMode === 'model') {
      if (!modelEl) return;
      if (modelDefaultOrbit) {
        modelEl.cameraOrbit = modelDefaultOrbit.theta + 'rad ' + modelDefaultOrbit.phi + 'rad ' + modelDefaultOrbit.radius + 'm';
      }
      if (modelDefaultFov) {
        modelEl.fieldOfView = modelDefaultFov + 'rad';
      }
      return;
    }
    zoom = 1;
    offsetX = 0;
    offsetY = 0;
    applyTransform();
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-trampoline-360]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    openViewer(btn.dataset.productId);
  });

  closeBtn && closeBtn.addEventListener('click', closeViewer);
  backdrop && backdrop.addEventListener('click', closeViewer);
  resetBtn && resetBtn.addEventListener('click', resetView);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && isOpen) closeViewer();
  });

  stage.addEventListener('pointerdown', function (event) {
    if (activeMode === 'model') return;
    isDragging = true;
    startX = event.clientX;
    startY = event.clientY;
    lastX = event.clientX;
    lastY = event.clientY;
    gestureAxis = null;
    stage.classList.add('is-dragging');
    stage.setPointerCapture && stage.setPointerCapture(event.pointerId);
  });

  stage.addEventListener('pointermove', function (event) {
    if (!isDragging) return;
    if (zoom > 1 && event.shiftKey) {
      offsetX += event.clientX - startX;
      offsetY += event.clientY - startY;
      startX = event.clientX;
      startY = event.clientY;
      lastX = event.clientX;
      lastY = event.clientY;
      applyTransform();
      return;
    }

    var axis = lockGestureAxis(event.clientX - startX, event.clientY - startY);
    if (!axis) return;

    if (axis === 'x') rotateColumns(event.clientX - lastX);
    if (axis === 'y') rotateRows(event.clientY - lastY);
  });

  function endPointer() {
    isDragging = false;
    gestureAxis = null;
    stage.classList.remove('is-dragging');
  }

  stage.addEventListener('pointerup', endPointer);
  stage.addEventListener('pointercancel', endPointer);
  stage.addEventListener('pointerleave', endPointer);

  stage.addEventListener('wheel', function (event) {
    if (activeMode === 'model') return;
    event.preventDefault();
    var nextZoom = clamp(zoom + (event.deltaY < 0 ? 0.12 : -0.12), 1, 2.5);
    if (nextZoom === 1) {
      offsetX = 0;
      offsetY = 0;
    }
    zoom = nextZoom;
    applyTransform();
  }, { passive: false });

  stage.addEventListener('touchmove', function (event) {
    if (activeMode === 'model') return;
    if (event.touches.length !== 2) return;
    event.preventDefault();
    var a = event.touches[0];
    var b = event.touches[1];
    var distance = Math.hypot(a.clientX - b.clientX, a.clientY - b.clientY);
    if (lastTouchDistance) {
      zoom = clamp(zoom + (distance - lastTouchDistance) / 180, 1, 2.5);
      if (zoom === 1) {
        offsetX = 0;
        offsetY = 0;
      }
      applyTransform();
    }
    lastTouchDistance = distance;
  }, { passive: false });

  stage.addEventListener('touchend', function () {
    lastTouchDistance = 0;
  });

  window.FizitiTrampoline360 = {
    open: openViewer,
    close: closeViewer
  };
})();
